import { AverageJobRatingListDataType } from "../../redux/mySpace/mySpaceTypes";
import {
  CircularAvatar,
  EmptyListPage,
  TableHeader,
  TableLoader,
} from "../commons";
import { AVERAGE_JOB_RATING_HEADERS } from "../../constant/tableHeadersConstants/mySpaceConstants";
import { formatDate } from "../../utils/commonFunctions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AverageImpressionGreyIcon,
  AverageImpressionYellowIcon,
  BadImpressionGreyIcon,
  BadImpressionYellowIcon,
  GoodImpressionGreyIcon,
  GoodImpressionYellowIcon,
  PerfectImpressionGreyIcon,
  PerfectImpressionYellowIcon,
  TerribleImpressionGreyIcon,
  TerribleImpressionYellowIcon,
} from "../../assets/images";
type AppProps = {
  fetching: boolean;
  averageJobRatingList: AverageJobRatingListDataType[] | [];
  averageJobRatingCount: number;
  averageJobRatingData: number;
};
const AverageJobRatingData = ({
  fetching,
  averageJobRatingList,
  averageJobRatingCount,
  averageJobRatingData,
}: AppProps) => {
  return (
    <>
    {averageJobRatingData?
    <div style={{      margin: "28px 0px 0px 39px",}}>
      <span
        style={{
          fontSize: "16px",
          padding:"5px 10px 5px 10px",
          borderRadius:'16px',
          color: "#82b01f",
          backgroundColor:'#e7f0d4'
        }}
        className=""
      >{`My Average Job Rating is ${averageJobRatingData?.toFixed(2)}`}</span>
      </div>
:''}
      <div style={{ marginTop: "36px", width: "95%", marginLeft: "29px" }}>
        {fetching ? (
          <TableLoader Rows={10} ColumnPerRow={7} />
        ) : averageJobRatingList?.length > 0 ? (
          <div className="jobsType pl-0 pr-0">
            <table className="table thead-light table-bordered">
              <thead className="text-start sticky-table-header">
                <TableHeader tableHeader={AVERAGE_JOB_RATING_HEADERS} />
              </thead>
              <tbody>
                {averageJobRatingList?.length > 0 &&
                  averageJobRatingList?.map((averageRating: any) => {
                    return (
                      <tr className="text-left">
                        {AVERAGE_JOB_RATING_HEADERS?.length > 0 &&
                          AVERAGE_JOB_RATING_HEADERS?.map((header: any) => {
                            if (header?.value == "job_type") {
                              return (
                                <td className="text-left">
                                  {`${averageRating?.job_id}_${
                                    averageRating?.job_type
                                      ? averageRating?.job_type
                                      : ""
                                  }_${
                                    averageRating?.period_ended
                                      ? formatDate(averageRating?.period_ended)
                                      : ""
                                  }`}
                                </td>
                              );
                            } else if (header?.value == "job_description") {
                              return (
                                <td
                                  className="text-left"
                                  style={{ minWidth: "230px" }}
                                >
                                  {averageRating?.job_description}
                                </td>
                              );
                            } else if (header?.value == "company_name") {
                              return (
                                <td className="text-left">
                                  {`${averageRating?.client_details?.company_name} (${averageRating?.client_details?.client_code})`}
                                </td>
                              );
                            } else if (header?.value == "job_manager") {
                              return (
                                <td
                                  className="text-left"
                                  style={{ minWidth: "170px" }}
                                >
                                  <div
                                    className="ml-2"
                                    style={{
                                      display: "flex",
                                      justifyContent: "left",
                                      alignItems: "center",
                                      gap: "7px",
                                    }}
                                  >
                                    <CircularAvatar
                                      name={`${averageRating?.job_manager?.first_name} ${averageRating?.job_manager?.last_name}`}
                                      image={
                                        averageRating?.job_manager
                                          ?.profile_pic &&
                                        averageRating?.job_manager?.profile_pic
                                          ?.file_url
                                      }
                                    />
                                    <div>
                                      {`${averageRating?.job_manager?.first_name} ${averageRating?.job_manager?.last_name} `}
                                    </div>
                                  </div>
                                  {/* <br></br> */}
                                  <p
                                    style={{
                                      color: "#6e7491",
                                      fontSize: "12px",
                                      marginLeft: "33px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {`${averageRating?.job_manager?.job_title}`}
                                  </p>
                                  <p
                                    style={{
                                      color: "#6e7491",
                                      fontSize: "12px",
                                      marginLeft: "33px",
                                    }}
                                  >
                                    {averageRating?.job_manager?.department}
                                  </p>
                                </td>
                              );
                            } else if (header?.value == "job_status") {
                              return (
                                <td className="text-left">
                                  {averageRating?.job_status === "Open" ? (
                                    <span className="Open">
                                      {averageRating?.job_status}
                                    </span>
                                  ) : (
                                    <span className="Close">
                                      {averageRating?.job_status}
                                    </span>
                                  )}
                                </td>
                              );
                            } else if (header?.value == "rating") {
                              return (
                                <td className="text-left">
                                    <div className="d-flex g-2">
                                        <div className=" mr-3">
                                          <img
                                            src={
                                              averageRating?.rating == "1"
                                                ? TerribleImpressionYellowIcon
                                                : TerribleImpressionGreyIcon
                                            }
                                            alt="Terrible"
                                          />
                                          <div
                                            style={{
                                              margin: "0px",
                                              fontSize: "10px",
                                              fontWeight:
                                                averageRating?.rating == "1"
                                                  ? "500"
                                                  : "normal",
                                              color:
                                                averageRating?.rating == "1"
                                                  ? "#262a44"
                                                  : "#9a9fb8",
                                            }}
                                          >
                                            {"Terrible (1)"}
                                          </div>
                                        </div>
                                        <div className=" mr-3">
                                          <img
                                            src={
                                              averageRating?.rating == "2"
                                                ? BadImpressionYellowIcon
                                                : BadImpressionGreyIcon
                                            }
                                            alt="bad"
                                          />
                                          <div
                                            style={{
                                              margin: "0px",
                                              fontSize: "10px",
                                              fontWeight:
                                                averageRating?.rating == "2"
                                                  ? "500"
                                                  : "normal",
                                              color:
                                                averageRating?.rating == "2"
                                                  ? "#262a44"
                                                  : "#9a9fb8",
                                            }}
                                          >
                                            {"Bad (2)"}
                                          </div>
                                        </div>
                                        <div className=" mr-3">
                                          <img
                                            src={
                                              averageRating?.rating == "3"
                                                ? AverageImpressionYellowIcon
                                                : AverageImpressionGreyIcon
                                            }
                                            alt="confused"
                                          />
                                          <div
                                            style={{
                                              margin: "0px",
                                              fontSize: "10px",
                                              fontWeight:
                                                averageRating?.rating == "3"
                                                  ? "500"
                                                  : "normal",
                                              color:
                                                averageRating?.rating == "3"
                                                  ? "#262a44"
                                                  : "#9a9fb8",
                                            }}
                                          >
                                            {"Okay (3)"}
                                          </div>
                                        </div>
                                        <div className=" mr-3">
                                          <img
                                            src={
                                              averageRating?.rating == "4"
                                                ? GoodImpressionYellowIcon
                                                : GoodImpressionGreyIcon
                                            }
                                            alt="good"
                                          />
                                          <div
                                            style={{
                                              margin: "0px",
                                              fontSize: "10px",
                                              fontWeight:
                                                averageRating?.rating == "4"
                                                  ? "500"
                                                  : "normal",
                                              color:
                                                averageRating?.rating == "4"
                                                  ? "#262a44"
                                                  : "#9a9fb8",
                                            }}
                                          >
                                            {"Good (4)"}
                                          </div>
                                        </div>
                                        <div className=" mr-3">
                                          <img
                                            src={
                                              averageRating?.rating == "5"
                                                ? PerfectImpressionYellowIcon
                                                : PerfectImpressionGreyIcon
                                            }
                                            alt="perfect"
                                          />
                                          <div
                                            style={{
                                              margin: "0px",
                                              fontSize: "10px",
                                              fontWeight:
                                                averageRating?.rating == "5"
                                                  ? "500"
                                                  : "normal",
                                              color:
                                                averageRating?.rating == "5"
                                                  ? "#262a44"
                                                  : "#9a9fb8",
                                            }}
                                          >
                                            {"Perfect (5)"}
                                          </div>
                                        </div>
                                      </div>
                                </td>
                                
                              );
                            }
                            else if (header?.value == "comment") {
                              return (
                                <td
                                  className="text-left"
                                  style={{ minWidth: "175px" }}
                                >
                                  {averageRating?.comment?averageRating?.comment:"NA"}
                                </td>
                              );
                            }

                            return null;
                          })}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="mt-5">
            {!fetching && averageJobRatingList?.length === 0 && (
              <EmptyListPage title="No Job Rating Found!" imageWidth="30%" />
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AverageJobRatingData;
